import { useFormatNumber } from '@dreamstack/i18n'
import type { Asset } from '@dreamstack/investors-graphql'
import last from 'lodash/last'
import { useMemo } from 'react'

const formatNumberOptions = { maximumFractionDigits: 1 }

export const useFormattedFile = (
  file?: Pick<Asset, 'title' | 'contentType' | 'fileName' | 'size' | 'url'>
) => {
  const format = useFormatNumber(formatNumberOptions)
  return useMemo(() => {
    if (!file || !file.fileName) return
    const safeSize = file?.size || 0
    const formattedFileSize = format(safeSize / 1000 / 1000) + 'MB'
    const formattedFileType = last(file?.fileName.split('.'))

    return { formattedFileSize, formattedFileType }
  }, [file, format])
}
